import CompositeSourceList from './views/CompositeSourceList.vue';
import permissions from '@Share/config/permissions';
import appConfig from '@/../appConfig';

const isBuilderEnabled = appConfig.compositeSourceBuilder === 'enabled';

export default [
  {
    path: '/composite-sources',
    name: 'CompositeSources',
    component: CompositeSourceList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Composite Sources',

      // PLURAL. The guard reads `to.meta.permissions` and only that
      // (src/router/index.js:176) — the singular `permission:` spelling in
      // register.routes.js:16 is a bug that silently disables the check, not a pattern.
      permissions: [permissions.DataSources.View],

      // Flag OFF makes the route inert rather than absent. The record has to stay
      // registered: `facilityRoutes` ends in `path: '/:id'` (facility.routes.js:17), so an
      // unregistered `/composite-sources` would be captured as a facility id and open a
      // broken viewer instead of refusing. `hidden` is the router's own convention for
      // this — the guard redirects it to the access-denied page (src/router/index.js:153).
      hidden: !isBuilderEnabled,
    },
  },
];
